import React from 'react';
import { Headline, Subtext } from '../../components/ScreenShell';
import { ChoiceChip } from '../../components/ui/Choice';
import { TextAreaField } from '../../components/ui/Field';
import { PrimaryButton } from '../../components/ui/PrimaryButton';
import { SITUATION_OPTIONS } from '../../data/quizOptions';
import { toggleValue } from '../../types/quiz';
import type { StepProps } from '../../types/quiz';
const NONE = 'Ninguna en particular';
export function StepContext({
  profile,
  update,
  onNext
}: StepProps) {
  function handleToggle(option: string) {
    if (option === NONE) {
      update({
        challenging_situations: profile.challenging_situations.includes(NONE) ? [] : [NONE]
      });
      return;
    }
    const withoutNone = profile.challenging_situations.filter(item => item !== NONE);
    update({
      challenging_situations: toggleValue(withoutNone, option)
    });
  }
  return <div className="flex flex-1 flex-col" data-id="element-110" data-mp="qs3he2aqfau6">
      <Headline data-id="element-111" data-mp="qt4ra3g0hrab">Cuéntanos un poquito más 💜</Headline>
      <Subtext data-id="element-112" data-mp="10x7ccwp4ruao">
        ¿En qué momento te gustaría que estas experiencias lo acompañaran?
      </Subtext>

      <div className="mt-6 space-y-3" data-id="element-113" data-mp="vxbkfvtpjtbh">
        {SITUATION_OPTIONS.map(option => <ChoiceChip key={option} label={option} selected={profile.challenging_situations.includes(option)} onSelect={() => handleToggle(option)} data-id="element-114" data-mp="qy8gyftdlv5m" />)}
      </div>

      <div className="mt-7" data-id="element-115" data-mp="1jm4axcrk98yp">
        <TextAreaField id="parent-context" label="Si quieres, cuéntanos una situación breve. (opcional)" value={profile.parent_context} onChange={value => update({
        parent_context: value
      })} placeholder="Por ejemplo: cuando algo no le sale a la primera, se frustra y dice que no puede." data-id="element-116" data-mp="1jme2v5w61q71" />
      </div>

      <div className="mt-auto pt-10" data-id="element-117" data-mp="22eoxydkkwjul">
        <PrimaryButton onClick={onNext} disabled={profile.challenging_situations.length === 0} data-id="element-118" data-mp="22frnoi660g8x">
          Continuar →
        </PrimaryButton>
      </div>
    </div>;
}